import { useState } from 'react';
import Diagram from '../Diagram';
import { cn } from '@/lib/utils';
import { DiagramLayerToggles, DEFAULT_DIAGRAM_LAYERS } from '../../components/ViewModeToggle';
import { PAGE_HEADER_SURFACE } from '../../components/PageHeader';
import type { DiagramLayers } from '../../components/ViewModeToggle';

/** Diagram tab. The quick nav beside it comes from SemanticLayerLayout. */
export default function SemanticLayerDiagram() {
  const [layers, setLayers] = useState<DiagramLayers>(DEFAULT_DIAGRAM_LAYERS);

  return (
    <div className="flex-1 min-h-0 overflow-hidden flex flex-col">
      {/* Bespoke markup — the layer toggles sit where a page's actions would — but on
          the shared header surface, so the bar matches every other page's chrome. */}
      <div
        className={cn(
          'flex flex-wrap items-center justify-between gap-3 w-full px-6 py-4 flex-shrink-0 z-10',
          PAGE_HEADER_SURFACE,
        )}
      >
        <h2 className="text-lg font-semibold text-foreground">Diagram</h2>
        <DiagramLayerToggles value={layers} onChange={setLayers} />
      </div>
      {/* Same canvas colour whether the diagram draws or shows its empty state */}
      <div className="flex-1 min-h-0 overflow-hidden bg-page-bg">
        <Diagram layers={layers} />
      </div>
    </div>
  );
}
